<template>
  <div class="project-solarPlant">
    <b-row>
      <b-col lg="6" md="6" sm="12" v-if="showToGuest('baseConfiguration', guestVisibleSections)">
        <legend>
          <strong>{{ $t('baseConfiguration') }}</strong>
        </legend>
        <SolarPlantItems :project="project" />
      </b-col>

      <b-col
        lg="6"
        md="6"
        sm="12"
        v-if="showToGuest('extendedConfiguration', guestVisibleSections)"
      >
        <legend>
          <strong>{{ $t('extendedConfiguration') }}</strong>
        </legend>

        <b-form-group
          horizontal
          :label="$t('cascadeConnectionState')"
          label-for="cascadeConnectionState"
          label-class="text-md-right"
          :label-cols="4"
          breakpoint="md"
        >
          <multiselect
            :placeholder="$t('cascadeConnectionState')"
            v-model="project.solarPlant.cascadeConnectionState"
            :options="optionsYesNo"
            :show-labels="false"
            :allow-empty="true"
          >
            <template slot="singleLabel" slot-scope="{ option }"
              ><b-badge :variant="yesNoColor(option)">{{ $t(option) }}</b-badge></template
            >
            <template slot="option" slot-scope="{ option }">
              <b-badge :variant="yesNoColor(option)">
                {{ $t(option) }}
              </b-badge></template
            >
          </multiselect>
        </b-form-group>

        <b-form-group
          horizontal
          :label="$t('networkSupplyManagementState')"
          label-for="networkSupplyManagementState"
          label-class="text-md-right"
          :label-cols="4"
          breakpoint="md"
        >
          <multiselect
            :placeholder="$t('networkSupplyManagementState')"
            v-model="project.solarPlant.networkSupplyManagementState"
            :options="getNetworkSupplyManagementStates"
            :show-labels="false"
            :allow-empty="true"
            @select="onNetworkSupplyManagementState"
          >
            <template slot="singleLabel" slot-scope="{ option }">{{ $t(option) }}</template>
            <template slot="option" slot-scope="{ option }">
              {{ $t(option) }}
            </template>
          </multiselect>
        </b-form-group>

        <b-form-group
          horizontal
          :label="$t('networkSupplyManagementPermanentRestrictionState')"
          label-for="networkSupplyManagementPermanentRestrictionState"
          label-class="text-md-right"
          :label-cols="4"
          breakpoint="md"
        >
          <multiselect
            :placeholder="$t('networkSupplyManagementPermanentRestrictionState')"
            v-model="project.solarPlant.networkSupplyManagementPermanentRestrictionState"
            :options="getNetworkSupplyManagementPermanentRestrictionStates"
            :show-labels="false"
            :allow-empty="true"
            :disabled="networkSupplyManagementPermanentRestrictionStateIsDisabled"
          >
            <template slot="singleLabel" slot-scope="{ option }">{{ $t(option) }}</template>
            <template slot="option" slot-scope="{ option }">
              {{ $t(option) }}
            </template>
          </multiselect>
        </b-form-group>
        <!-- 
        <b-form-group
          horizontal
          :label="$t('networkSupplyManagementXOverState')"
          label-for="networkSupplyManagementXOverState"
          label-class="text-md-right"
          :label-cols="4"
          breakpoint="md"
        >
          <multiselect
            :placeholder="$t('networkSupplyManagementXOverState')"
            v-model="project.solarPlant.networkSupplyManagementXOverState"
            :options="getNetworkSupplyManagementXOverStates"
            :show-labels="false"
            :allow-empty="true"
          >
            <template slot="singleLabel" slot-scope="{ option }">{{ $t(option) }}</template>
            <template slot="option" slot-scope="{ option }">
              {{ $t(option) }}
            </template>
          </multiselect>
        </b-form-group> -->

        <b-form-group
          horizontal
          :label="$t('netOutputState')"
          label-for="netOutputState"
          label-class="text-md-right"
          :label-cols="4"
          breakpoint="md"
        >
          <multiselect
            :placeholder="$t('netOutputState') + ' ' + $t('select')"
            v-model="project.solarPlant.netOutputStates"
            :options="getNetOutputStates"
            :close-on-select="false"
            :clear-on-select="false"
            :multiple="true"
            :taggable="true"
            :show-labels="true"
            :allow-empty="true"
            :selectLabel="$t('select')"
            :selectedLabel="$t('selected')"
            :deselectLabel="$t('remove_selection')"
          >
            <template slot="singleLabel" slot-scope="{ option }">{{ $t(option) }}</template>
            <template slot="option" slot-scope="{ option }">
              {{ $t(option) }}
            </template>
            <template slot="tag" slot-scope="{ option }">
              <b-badge>
                {{ $t(option) }}
              </b-badge>
            </template>
          </multiselect>
        </b-form-group>

        <b-form-group
          horizontal
          :label="$t('electricMeterMountingState')"
          label-for="electricMeterMountingState"
          label-class="text-md-right"
          :label-cols="4"
          breakpoint="md"
        >
          <multiselect
            :placeholder="$t('electricMeterMountingState')"
            v-model="project.solarPlant.electricMeterMountingState"
            :options="getElectricMeterMountingStates"
            :show-labels="false"
            :allow-empty="true"
          >
            <template slot="singleLabel" slot-scope="{ option }">{{ $t(option) }}</template>
            <template slot="option" slot-scope="{ option }">
              {{ $t(option) }}
            </template>
          </multiselect>
        </b-form-group>

        <!-- <b-form-group
          horizontal
          :label="$t('storageCouplingState')"
          label-for="storageCouplingState"
          label-class="text-md-right"
          :label-cols="4"
          breakpoint="md"
        >
          <multiselect
            :placeholder="$t('storageCouplingState')"
            v-model="project.solarPlant.storageCouplingState"
            :options="getStorageCouplingStates"
            :show-labels="false"
            :allow-empty="true"
          >
            <template slot="singleLabel" slot-scope="{ option }">{{ $t(option) }}</template>
            <template slot="option" slot-scope="{ option }">
              {{ $t(option) }}
            </template>
          </multiselect>
        </b-form-group> -->

        <b-form-group
          horizontal
          :label="$t('yearlyPower')"
          label-for="yearlyPower"
          label-class="text-md-right"
          :label-cols="4"
          breakpoint="md"
        >
          <InputNumber
            v-model="project.solarPlant.yearlyPower"
            mode="decimal"
            :minFractionDigits="2"
            suffix=" kWh"
            locale="de-DE"
            :placeholder="$t('yearlyPower')"
          />
        </b-form-group>

        <!-- <b-form-group
          horizontal
          :label="$t('houseFuseState')"
          label-for="houseFuseState"
          label-class="text-md-right"
          :label-cols="4"
          breakpoint="md"
        >
          <multiselect
            :placeholder="$t('houseFuseState')"
            v-model="project.solarPlant.houseFuseState"
            :options="getHouseFuseStates"
            :show-labels="false"
            :allow-empty="true"
          >
            <template slot="singleLabel" slot-scope="{ option }">{{ $t(option) }}</template>
            <template slot="option" slot-scope="{ option }">
              {{ $t(option) }}
            </template>
          </multiselect>
        </b-form-group> -->

        <b-form-group
          horizontal
          :label="$t('houseFuseAmpere')"
          label-for="houseFuseAmpere"
          label-class="text-md-right"
          :label-cols="4"
          breakpoint="md"
        >
          <InputNumber
            v-model="project.solarPlant.houseFuseAmpere"
            suffix=" A"
            locale="de-DE"
            :placeholder="$t('houseFuseAmpere')"
          />
        </b-form-group>

        <b-form-group
          horizontal
          :label="$t('electricMeterCombinationState')"
          label-for="electricMeterCombinationState"
          label-class="text-md-right"
          :label-cols="4"
          breakpoint="md"
        >
          <multiselect
            :placeholder="$t('electricMeterCombinationState')"
            v-model="project.solarPlant.electricMeterCombinationState"
            :options="optionsYesNo"
            :show-labels="false"
            :allow-empty="true"
          >
            <template slot="singleLabel" slot-scope="{ option }"
              ><b-badge :variant="yesNoColor(option)">{{ $t(option) }}</b-badge></template
            >
            <template slot="option" slot-scope="{ option }">
              <b-badge :variant="yesNoColor(option)">
                {{ $t(option) }}
              </b-badge></template
            >
          </multiselect>
        </b-form-group>

        <b-form-group
          horizontal
          :label="$t('electricMeterDeregistrationState')"
          label-for="electricMeterDeregistrationState"
          label-class="text-md-right"
          :label-cols="4"
          breakpoint="md"
        >
          <multiselect
            :placeholder="$t('electricMeterDeregistrationState')"
            v-model="project.solarPlant.electricMeterDeregistrationState"
            :options="optionsYesNo"
            :show-labels="false"
            :allow-empty="true"
          >
            <template slot="singleLabel" slot-scope="{ option }">{{ $t(option) }}</template>
            <template slot="option" slot-scope="{ option }">
              {{ $t(option) }}
            </template>
          </multiselect>
        </b-form-group>

        <b-form-group
          horizontal
          :label="$t('solarPlantType')"
          label-for="solarPlantType"
          label-class="text-md-right"
          :label-cols="4"
          breakpoint="md"
        >
          <multiselect
            :placeholder="$t('solarPlantType')"
            v-model="project.solarPlant.solarPlantType"
            :options="getEnumValues('SolarPlantType')"
            :show-labels="false"
            :allow-empty="true"
          >
            <template slot="singleLabel" slot-scope="{ option }">{{ $t(option) }}</template>
            <template slot="option" slot-scope="{ option }">
              {{ $t(option) }}
            </template>
          </multiselect>
        </b-form-group>

        <b-form-group
          horizontal
          :label="$t('islandOperationIntended')"
          label-for="islandOperationIntended"
          label-class="text-md-right"
          :label-cols="4"
          breakpoint="md"
        >
          <multiselect
            :placeholder="$t('islandOperationIntended')"
            v-model="project.solarPlant.islandOperationIntended"
            :options="optionsYesNo"
            :show-labels="false"
            :allow-empty="true"
          >
            <template slot="singleLabel" slot-scope="{ option }"
              ><b-badge :variant="yesNoColor(option)">{{ $t(option) }}</b-badge></template
            >
            <template slot="option" slot-scope="{ option }">
              <b-badge :variant="yesNoColor(option)">
                {{ $t(option) }}
              </b-badge></template
            >
          </multiselect>
        </b-form-group>

        <b-form-group
          horizontal
          :label="$t('motorStartup')"
          label-for="motorStartup"
          label-class="text-md-right"
          :label-cols="4"
          breakpoint="md"
        >
          <multiselect
            :placeholder="$t('motorStartup')"
            v-model="project.solarPlant.motorStartup"
            :options="optionsYesNo"
            :show-labels="false"
            :allow-empty="true"
          >
            <template slot="singleLabel" slot-scope="{ option }"
              ><b-badge :variant="yesNoColor(option)">{{ $t(option) }}</b-badge></template
            >
            <template slot="option" slot-scope="{ option }">
              <b-badge :variant="yesNoColor(option)">
                {{ $t(option) }}
              </b-badge></template
            >
          </multiselect>
        </b-form-group>

        <b-form-group
          horizontal
          :label="$t('networkSupplyType')"
          label-for="networkSupplyType"
          label-class="text-md-right"
          :label-cols="4"
          breakpoint="md"
        >
          <multiselect
            :placeholder="$t('networkSupplyType')"
            v-model="project.solarPlant.networkSupplyType"
            :options="getEnumValues('NetworkSupplyType')"
            :show-labels="false"
            :allow-empty="true"
          >
            <template slot="singleLabel" slot-scope="{ option }">{{ $t(option) }}</template>
            <template slot="option" slot-scope="{ option }">
              {{ $t(option) }}
            </template>
          </multiselect>
        </b-form-group>

        <b-form-group
          horizontal
          :label="$t('measuringConcept')"
          label-for="measuringConcept"
          label-class="text-md-right"
          :label-cols="4"
          breakpoint="md"
        >
          <b-form-input
            v-model="project.solarPlant.measuringConcept"
            type="text"
            :placeholder="$t('measuringConcept')"
          />
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Multiselect from 'vue-multiselect';
import { yesNo } from '@/helpers/enums';
import { getYesNoStateColor } from '@/helpers/colors';
import InputNumber from 'primevue/inputnumber';
import { showToGuest } from '@/helpers/userCapabilities';
import SolarPlantItems from '@/components/SolarPlant/SolarPlantItems.vue';

export default {
  components: {
    Multiselect,
    InputNumber,
    SolarPlantItems,
  },
  props: {
    project: { type: Object },
  },
  data() {
    return {
      guestVisibleSections: {
        baseConfiguration: true,
        extendedConfiguration: false,
      },
    };
  },

  computed: {
    ...mapGetters([
      'getNetworkSupplyManagementStates',
      'getNetworkSupplyManagementPermanentRestrictionStates',
      'getNetworkSupplyManagementXOverStates',
      'getNetOutputStates',
      'getStorageCouplingStates',
      'getElectricMeterMountingStates',
      'getHouseFuseStates',
      'getEnumValues',
    ]),

    networkSupplyManagementPermanentRestrictionStateIsDisabled() {
      return this.project.solarPlant.networkSupplyManagementState === 'PERMANENT_RESTRICTION'
        ? false
        : true;
    },
    optionsYesNo() {
      return yesNo();
    },
    /**
     * Bei der Zählerzusammenlegung/Zählerabmeldung bleibt der erste Zähler immer bestehen. Es können nur Zähler 2 und 3 ausgewählt werden.
     */
    projectElectricMeters() {
      const electricMeters = [];
      if (
        this.project.customer.electricMeterNumber2 &&
        this.project.customer.electricMeterNumber2 !== ''
      ) {
        electricMeters.push(this.project.customer.electricMeterNumber2);
      }
      if (
        this.project.customer.electricMeterNumber3 &&
        this.project.customer.electricMeterNumber3 !== ''
      ) {
        electricMeters.push(this.project.customer.electricMeterNumber3);
      }
      return electricMeters;
    },
  },
  methods: {
    ...mapActions([
      'fetchNetworkSupplyManagementStates',
      'fetchNetworkSupplyManagementPermanentRestrictionStates',
      'fetchNetworkSupplyManagementXOverStates',
      'fetchNetOutputStates',
      'fetchStorageCouplingStates',
      'fetchElectricMeterMountingStates',
      'fetchHouseFuseStates',
      'fetchEnumValues',
    ]),
    onNetworkSupplyManagementState(state) {
      if (state === 'FRE' || state === 'NONE') {
        this.project.solarPlant.networkSupplyManagementPermanentRestrictionState = null;
      }
    },
    yesNoColor(state) {
      return getYesNoStateColor(state);
    },
    async setup() {
      try {
        await Promise.all([
          this.fetchNetworkSupplyManagementStates(),
          this.fetchNetworkSupplyManagementPermanentRestrictionStates(),
          this.fetchNetworkSupplyManagementXOverStates(),
          this.fetchNetOutputStates(),
          this.fetchStorageCouplingStates(),
          this.fetchElectricMeterMountingStates(),
          this.fetchHouseFuseStates(),
          this.fetchEnumValues('SolarPlantType'),
          this.fetchEnumValues('NetworkSupplyType'),
        ]);
      } catch (error) {
        console.error('Error in setup:', error);
      }
    },
    showToGuest,
  },
  async mounted() {
    await this.setup();
  },
};
</script>
